// extracted by mini-css-extract-plugin
module.exports = {"texts":"Texts_texts__qXe44","texts__heading":"Texts_texts__heading__y_v0j"};